import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { timeout, map } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { SharedService } from "./shared.service";

@Injectable()
export class AngularHttpInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private sharedService: SharedService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url === "./lsrsdp/authenticate" ||
      req.url === "../lsrsdp/authenticate"
    ) {
      const authRequest = req.clone();
      authRequest.body.sessionId = this.authService.sessionId;

      return next.handle(authRequest).pipe(timeout(120000));
    } else if (req.url.indexOf("s3") >= 0) {
      const s3Request = req.clone();
      return next.handle(s3Request).pipe(timeout(120000));
    } else if (this.authService.getIsLoggedIn()) {
      const authToken = this.authService.getToken();

      const authRequest = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + authToken),
      });

      if (authRequest.body != null) {
        authRequest.body.sessionId = this.authService.sessionId;
      }

      return next.handle(authRequest).pipe(
        timeout(120000),
        map((res: HttpEvent<any>) => {
          if (res instanceof HttpResponse) {
            // console.log('event--->' + res.status);
          }

          if (res instanceof HttpResponse && (res as any).body) {
            if ((res as any).body.refreshJWT) {
              this.authService.setToken((res as any).body.refreshJWT);
            }
            this.authService.clearAuthTimer();
            if (this.sharedService.isInterviewer) {
              this.authService.setAuthTimer(305);
            } else {
              this.authService.setAuthTimer(905);
            }
            const now = new Date();
            this.authService.setExpirationDate(
              new Date(now.getTime() + 900 * 1000)
            );
          }
          return res;
        })
      );
    } else {
      const request = req.clone();

      return next.handle(request).pipe(timeout(120000));
    }
  }
}
